import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreationAcceptance } from '../../../../../types/campaign'
import { CreationAcceptancesSliceModel } from '../models/creation-acceptances-slice.model'
import { produce } from 'immer'

const defaultState: CreationAcceptancesSliceModel = {
  setDisableSendToAcceptance: false,
  loadingAcceptanceList: false,
  acceptancesList: [],
  loaded: false,
}

const initialState: CreationAcceptancesSliceModel = produce(defaultState, draft => draft)

const creationAcceptancesSlice = createSlice({
  name: 'creationsForm',
  initialState: initialState,
  reducers: {
    setDisableSendToAcceptance(state, action: PayloadAction<boolean>) {
      state.setDisableSendToAcceptance = action.payload
    },
    setLoadingAcceptancesList(state, action: PayloadAction<boolean>) {
      state.loadingAcceptanceList = action.payload
    },
    setAcceptancesList(state, action: PayloadAction<CreationAcceptance[]>) {
      state.acceptancesList = action.payload
      state.loaded = true
    },
    resetState() {
      return defaultState
    },
  },
})

export const selectAcceptancesForCreation = createSelector(
  [
    state =>
      (state as { creationAcceptances: CreationAcceptancesSliceModel }).creationAcceptances
        .acceptancesList,
    (state, creationId) => creationId,
  ],
  (acceptancesObj, creationId) => {
    return acceptancesObj.map(acceptancesObj => {
      return {
        ...acceptancesObj,
        acceptances: acceptancesObj.acceptances.filter(
          acceptanceDetails => acceptanceDetails.creationId === creationId
        ),
      }
    })
  }
)

export const creationAcceptancesActions = creationAcceptancesSlice.actions

export default creationAcceptancesSlice
